import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Button } from '@wit-support/ui';
export const CancelButton = React.forwardRef(({ children = 'Отмена', ...props }, ref) => (_jsx(Button, { ref: ref, type: "button", variant: "ghost", ...props, children: children })));
CancelButton.displayName = 'CancelButton';
//# sourceMappingURL=cancel-button.js.map